<mat-card appearance="outlined" class="number-card" [style.background-color]="colour" title="{{title}}">
  <div class="number-card-content">
    <div>{{number}}</div>
    <div>{{label}}</div>
    <div>{{owner}}</div>
  </div>
</mat-card>
